var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectPhases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_794_1491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1041 5C18.1041 4.775 17.9916 4.60625 17.8229 4.49375L13.8854 2.24375C13.7729 2.1875 13.7166 2.1875 13.6041 2.1875C13.4916 2.1875 13.4354 2.1875 13.3229 2.24375L9.66663 4.325L6.01038 2.24375C5.89788 2.1875 5.84163 2.1875 5.72913 2.1875C5.61663 2.1875 5.56038 2.1875 5.44788 2.24375L1.51038 4.49375C1.34163 4.60625 1.22913 4.775 1.22913 5V16.25C1.22913 16.5875 1.45413 16.8125 1.79163 16.8125C1.90413 16.8125 1.96038 16.7562 2.07288 16.7562L5.72913 14.675L9.38538 16.7562C9.49788 16.8125 9.55413 16.8125 9.66663 16.8125C9.77913 16.8125 9.83538 16.8125 9.94788 16.7562L13.6041 14.675L17.2604 16.7562C17.3166 16.8125 17.4291 16.8125 17.5416 16.8125C17.8791 16.8125 18.1041 16.5875 18.1041 16.25V5ZM2.35413 5.3375L5.16663 3.70625V13.6625L2.35413 15.2937V5.3375ZM9.10413 15.2937L6.29163 13.6625V3.70625L9.10413 5.3375V15.2937ZM13.0416 13.6625L10.2291 15.2937V5.3375L13.0416 3.70625V13.6625ZM14.1666 13.6625V3.70625L16.9791 5.3375V15.2937L14.1666 13.6625Z",
    fill: "#DCE0E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_794_1491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.666626 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectPhases);
export default __webpack_public_path__ + "static/media/project_phases.7b8ea6fa2521299a44fbc2530685a99d.svg";
export { ForwardRef as ReactComponent };